import { useEffect } from "react";
import { api } from "@/lib/api";

/**
 * Lädt Google Analytics (gtag.js) und/oder Google Tag Manager NUR, wenn eine ID in der
 * Admin-Oberfläche (Integrations) hinterlegt ist. Der Consent-Mode-Default (alles "denied")
 * wird bereits ganz am Anfang von public/index.html gesetzt, bevor dieses Skript überhaupt lädt -
 * das ist hier nur der zweite Schritt: das eigentliche Google-Tag einhängen, sobald eine ID existiert.
 *
 * Wenn noch keine ID hinterlegt ist, tut diese Komponente schlicht gar nichts.
 */
export function GoogleTag() {
  useEffect(() => {
    api.get("/config/analytics").then(({ data }) => {
      const { ga_measurement_id, gtm_container_id, ads_conversion_id } = data || {};

      if (gtm_container_id) {
        const s = document.createElement("script");
        s.async = true;
        s.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtm_container_id}');`;
        document.head.appendChild(s);
      }

      // Beide IDs sollen unabhängig voneinander funktionieren: Google Ads-Conversion-Tracking
      // (AW-...) braucht kein separates GA4-Measurement-ID (G-...), um zu laufen.
      const primaryId = ga_measurement_id || ads_conversion_id;
      if (primaryId) {
        const s = document.createElement("script");
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${primaryId}`;
        document.head.appendChild(s);
        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
        window.gtag("js", new Date());
        if (ga_measurement_id) window.gtag("config", ga_measurement_id);
        if (ads_conversion_id) window.gtag("config", ads_conversion_id);
      }
    }).catch(() => {});
  }, []);

  return null;
}

/** Von CookieConsent (und ggf. woanders) aufgerufen, um die tatsächliche Zustimmung an Google zu melden. */
export function updateGoogleConsent(granted) {
  if (typeof window.gtag !== "function") return;
  const state = granted ? "granted" : "denied";
  window.gtag("consent", "update", {
    ad_user_data: state,
    ad_personalization: state,
    ad_storage: state,
    analytics_storage: state,
  });
}
